import { Typography } from '@mui/material';

type Props = {
  current: number;
  max: number;
};

const Counter = ({ current, max }: Props) => {
  return (
    <Typography color={'textPrimary'}>
      {`${current + 1}`.padStart(2, '0')} /
      <Typography component={'span'} color={'textSecondary'}>
        {`${max}`.padStart(2, '0')}
      </Typography>
    </Typography>
  );
};

export default Counter;
